export default __webpack_public_path__ + "static/media/SD-Home-slider-01.9f9731df.png";